module.exports = __webpack_public_path__ + "img/20220623150758.0affb076.png";